import React, { useState } from "react";
import { HiPaperAirplane } from "react-icons/hi2";
import Button from "../../common/Button/Button";
import "./Contact.scss";
import { VscSend } from "react-icons/vsc";

const Contact = () => {
    const [formData, setFormData] = useState({
        nombre: "",
        apellidos: "",
        email: "",
        telefono: "",
        mensaje: "",
    });

    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        // Simular envío
        setTimeout(() => {
            console.log("Form data:", formData);
            setIsSubmitting(false);
            // Aquí iría la lógica de envío real
        }, 1000);
    };

    return (
        <section id="contact" className="contact">
            <div className="contact__container">
                <div className="contact__content">
                    <div className="contact__header">
                        <h2 className="contact__title">
                            ¿Tienes dudas o necesitas ayuda?
                        </h2>
                        <p className="contact__subtitle">
                            Completa el formulario y nuestro equipo te
                            responderá lo antes posible. Estamos aquí para
                            ayudarte a iniciar tu proyecto.
                        </p>
                    </div>

                    <form className="contact__form" onSubmit={handleSubmit}>
                        <div className="form-row">
                            <div className="form-group">
                                <label htmlFor="nombre">Nombre</label>
                                <input
                                    type="text"
                                    id="nombre"
                                    name="nombre"
                                    value={formData.nombre}
                                    onChange={handleChange}
                                    placeholder="Tu nombre"
                                    required
                                    disabled={isSubmitting}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="apellidos">Apellidos</label>
                                <input
                                    type="text"
                                    id="apellidos"
                                    name="apellidos"
                                    value={formData.apellidos}
                                    onChange={handleChange}
                                    placeholder="Tus apellidos"
                                    required
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="tu@email.com"
                                    required
                                    disabled={isSubmitting}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="telefono">Teléfono</label>
                                <input
                                    type="tel"
                                    id="telefono"
                                    name="telefono"
                                    value={formData.telefono}
                                    onChange={handleChange}
                                    placeholder="+34 600 000 000"
                                    required
                                    disabled={isSubmitting}
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="mensaje">Mensaje</label>
                            <textarea
                                id="mensaje"
                                name="mensaje"
                                value={formData.mensaje}
                                onChange={handleChange}
                                placeholder="Cuéntanos sobre tu proyecto..."
                                rows="5"
                                required
                                disabled={isSubmitting}
                            />
                        </div>

                        <Button
                            variant="filled"
                            icon={<VscSend />}
                            animationType="pop"
                            className="form-submit-button"
                        >
                            {isSubmitting ? "Enviando..." : "Enviar mensaje"}
                        </Button>
                    </form>
                </div>

                <div className="contact__illustration">
                    <div className="illustration-container">
                        <div className="illustration-glow"></div>
                        <div className="illustration-content">
                            <svg
                                viewBox="0 0 400 400"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle
                                    cx="200"
                                    cy="200"
                                    r="150"
                                    stroke="rgba(85, 153, 163, 0.2)"
                                    strokeWidth="2"
                                    fill="none"
                                />
                                <circle
                                    cx="200"
                                    cy="200"
                                    r="120"
                                    stroke="rgba(85, 153, 163, 0.3)"
                                    strokeWidth="2"
                                    fill="none"
                                />

                                <g transform="translate(150, 150)">
                                    <rect
                                        x="0"
                                        y="20"
                                        width="100"
                                        height="70"
                                        rx="5"
                                        fill="rgba(85, 153, 163, 0.2)"
                                        stroke="rgba(85, 153, 163, 0.6)"
                                        strokeWidth="2"
                                    />
                                    <path
                                        d="M 0 20 L 50 55 L 100 20"
                                        stroke="rgba(85, 153, 163, 0.6)"
                                        strokeWidth="2"
                                        fill="none"
                                    />
                                    <line
                                        x1="0"
                                        y1="20"
                                        x2="50"
                                        y2="55"
                                        stroke="rgba(85, 153, 163, 0.6)"
                                        strokeWidth="2"
                                    />
                                    <line
                                        x1="100"
                                        y1="20"
                                        x2="50"
                                        y2="55"
                                        stroke="rgba(85, 153, 163, 0.6)"
                                        strokeWidth="2"
                                    />
                                </g>

                                <circle
                                    cx="80"
                                    cy="100"
                                    r="4"
                                    fill="rgba(85, 153, 163, 0.4)"
                                />
                                <circle
                                    cx="320"
                                    cy="120"
                                    r="4"
                                    fill="rgba(85, 153, 163, 0.4)"
                                />
                                <circle
                                    cx="100"
                                    cy="300"
                                    r="4"
                                    fill="rgba(85, 153, 163, 0.4)"
                                />
                                <circle
                                    cx="300"
                                    cy="280"
                                    r="4"
                                    fill="rgba(85, 153, 163, 0.4)"
                                />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
